import { IntlFormatters } from 'react-intl';
import * as Yup from 'yup';
import { getNewPasswordValidationSchema } from '../../validations/newPasswordValidationSchema';
import {
  getBasicEmailValidation,
  getFirstNameValidation,
  getLastNameValidation,
} from '../../validations/user/userCommonValidations';
import messages from './messages';

export interface IRegisterValidationSchemaProps {
  formatMessage: IntlFormatters['formatMessage'];
  isOryRegistrationFFEnabled?: boolean;
}

export interface IRegisterFormData {
  agree: boolean;
  captcha: string;
  companyName: string;
  email: string;
  firstName: string;
  lastName: string;
  newsletters: boolean;
  password?: string;
  referrer?: string;
}

export function getRegisterDefaultValues(isOryRegistrationFFEnabled: boolean | undefined): IRegisterFormData {
  return {
    agree: false,
    captcha: '',
    companyName: '',
    email: '',
    firstName: '',
    lastName: '',
    newsletters: false,
    password: isOryRegistrationFFEnabled ? undefined : '',
    referrer: ''
  };
}

export function getRegisterValidationSchema({
  formatMessage,
  isOryRegistrationFFEnabled,
}: IRegisterValidationSchemaProps) {
  const passwordValidationSchema = !isOryRegistrationFFEnabled
    ? getNewPasswordValidationSchema(formatMessage)
    : { password: Yup.string() };

  return Yup.object().shape({
    agree: Yup.boolean()
      .oneOf([true], formatMessage(messages.registerAgreeRequired))
      .required(formatMessage(messages.registerAgreeRequired)),
    captcha: Yup.string().required(formatMessage(messages.registerRequired)),
    companyName: Yup.string().trim().required(formatMessage(messages.registerRequired)),
    email: getBasicEmailValidation(
      formatMessage(messages.registerEmailInvalid),
      formatMessage(messages.registerRequired)
    ),
    firstName: getFirstNameValidation(true, formatMessage),
    lastName: getLastNameValidation(formatMessage),
    ...passwordValidationSchema,
    newsletters: Yup.boolean().required(),
    referrer: Yup.string(),
  });
}
